import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, of, shareReplay, switchMap } from 'rxjs';
import { ProfilerService } from '../../profiler.service';

@Component({
    templateUrl: './header-button.component.html',
    styleUrls: ['./header-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderButtonComponent {
    private readonly router = inject(Router);
    private readonly profilerService = inject(ProfilerService);

    readonly itemsCount$ = of(0).pipe(
        switchMap(() => this.profilerService.getItemsCount()),
        map((x) => (x > 0 ? (x > 99 ? '99+' : x + '') : null)),
        shareReplay({ bufferSize: 1, refCount: false }),
    );

    @HostBinding('class') classes = 'relative';

    onButtonClick() {
        this.router.navigate(['profiler']);
    }
}
